/** @jsx h */
import { h } from 'preact'

const PhoneIcon = ({
  style = {},
  fill = '#757575',
  stroke = '#757575',
  width = '10.296',
  height = '15.074',
  className = '',
  viewBox = '0 0 10.296 15.074'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_phone-icon ${className}`}
  >
    <path
      d='M681.187,1060.717a6.054,6.054,0,0,0,2.145,2.761s1.212-.621,1.638-.831a4.377,4.377,0,0,1,1.989,2.4,6.919,6.919,0,0,1-2.089,2.342c-1.271-.431-3.821-1.635-5.793-5.632h0c-1.972-4-1.376-6.753-.945-8.024a6.925,6.925,0,0,1,3.13-.232,4.375,4.375,0,0,1,.694,3.039c-.426.21-1.656.795-1.656.795a6.057,6.057,0,0,0,.887,3.382Z'
      transform='translate(-677.188 -1052.871)'
      fill='none'
      stroke={stroke}
      strokeMiterlimit='10'
      strokeWidth='1'
    />
  </svg>
)

export default PhoneIcon
